<template>
  <div class="container mt-1 mb-1" >
    <div class="card">
      <div class="row no-gutters">
        <div class="col-md-4 my-auto">
            <img class="card-img" :src="item.image">
        </div>
        <div class="col-md-8">
          <div class="card-body">
            <div class="row-12">
              <div class="col">
                <h3 class="card-title">{{item.name}}</h3>
              </div>
              <template v-if="reserveButtonVisible">
                <div class="col mb-10">
                  {{item.comment}}
                </div>
                <div class="col price-a border rounded-3">
                  <h5>
                    <label class="ps-3 py-1">ご利用料金<span v-if="item.per">（{{item.per}}）</span></label>
                    <div class="bg-light text-black fs-5 fw-normal p-2 ps-4 mx-2 rounded-1">
                      <div v-for="price in item.prices" :key="price">
                        {{numberFormat(price.unit_price)}}{{price.unit}}
                      </div>
                      <div v-if="item.note">{{item.note}}</div>
                    </div>
                  </h5>
                </div>
                <div v-for="(alternative, index) in item.alternatives" :key="index" class="col price-a border rounded-3 mt-2">
                  <h5>
                    <label class="ps-3 py-1">{{alternative.title}}</label>
                    <div class="bg-light text-black fs-5 fw-normal p-2 ps-4 mx-2 rounded-1">
                      <div v-for="price in alternative.prices" :key="price">
                        {{numberFormat(price.unit_price)}}{{price.unit}}
                      </div>
                      <div v-if="alternative.note">{{alternative.note}}</div>
                    </div>
                  </h5>
                </div>
                <div class="col-12 reserveButton">
                  <button type="button" class="btn btn-primary" @click="reserveClick()">{{item.name}}を予約</button>
                </div>
              </template>
              <template v-else>
                <div class="col mb-10">
                  {{item.comment}}
                </div>
                <div class="col price-b border rounded-3">
                  <h5>
                    <label class="ps-3 py-1">ご利用料金<span v-if="item.per">（{{item.per}}）</span></label>
                    <div class="bg-light text-black fs-5 fw-normal p-2 ps-4 mx-2 rounded-1">
                      <div v-for="price in item.prices" :key="price">
                        {{numberFormat(price.unit_price)}}{{price.unit}}
                      </div>
                      <div v-if="item.note">{{item.note}}</div>
                    </div>
                  </h5>
                </div>
                <div v-for="(alternative, index) in item.alternatives" :key="index" class="col price-a border rounded-3 mt-2">
                  <h5>
                    <label class="ps-3 py-1">{{alternative.title}}</label>
                    <div class="bg-light text-black fs-5 fw-normal p-2 ps-4 mx-2 rounded-1">
                      <div v-for="price in alternative.prices" :key="price">
                        {{numberFormat(price.unit_price)}}{{price.unit}}
                      </div>
                      <div v-if="alternative.note">{{alternative.note}}</div>
                    </div>
                  </h5>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReserveCard',
  props: {
    'item': { default: [{ plan:'', name:'', headline:'', text:'', prices: [], image:'', note:'', per:'', alternatives: [] }]},
    'reserveButtonVisible': { default: true },
  },
  data: () => ({
  }),
  methods: {
    reserveClick: function() {
      // プランを予約画面に渡すためにストアに情報を設定
      this.$store.dispatch('updateItem', this.item);
      // 親コンポーネントへボタン押下されたことを伝達
      this.$emit('catchReserveClick');
    },
    numberFormat: function(num){
      if (isNaN(num)) {
        return num
      } else {
        try {
          return parseInt(num).toLocaleString()
        } catch {
          return num
        }
      }
    }
  },
}
</script>

<style scoped>
.price-a {
  text-align: left;
  bottom: 50px;
  right: 10px;
  background-color: #d5a866;
  color: white;
}
.price-b {
  text-align: left;
  bottom: 5px;
  right: 10px;
  background-color: #d5a866;
  color: white;
}
.reserveButton {
  text-align: right;
  margin-top: 15px;
  bottom: 5px;
  right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>